import { render, staticRenderFns } from "./plan-detail.vue?vue&type=template&id=0cba6916&scoped=true"
import script from "./plan-detail.vue?vue&type=script&lang=js"
export * from "./plan-detail.vue?vue&type=script&lang=js"
import style0 from "./plan-detail.vue?vue&type=style&index=0&id=0cba6916&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cba6916",
  null
  
)

export default component.exports